import React, { useEffect } from 'react';
import Tour from 'reactour';
import { Button } from 'reactstrap';
import { FMessage } from '../../hoc/IntlComponents';

const FlowDirectLickTour = ({ handleDirectLinkTourClose }) => {

  useEffect(() => {
    document.querySelector('body').style.overflow = 'hidden';
    return () => (document.querySelector('body').style.overflow = 'auto');
  }, []);

  return (
    <Tour
      isOpen
      showButtons={false}
      showNavigation={false}
      showCloseButton={false}
      showNumber={false}
      className="tour flow-direct-link-tour"
      onRequestClose={handleDirectLinkTourClose}
      steps={[
        {
          selector: '#direct-link-card',
          content: () => {
            return (
              <>
                <p>
                  <FMessage id="flow.direct-link-tour.text" />
                </p>
                <Button color="primary" size="sm" onClick={handleDirectLinkTourClose}>
                  <FMessage id="flow.direct-link-tour.button" />
                </Button>
              </>
            );
          },
          position: 'top',
        },
      ]}
    />
  );
};

export default FlowDirectLickTour;
